import { call, put } from 'redux-saga/effects';
import { setUserDetails } from '../account/accountSlice';
import {
  setResendEmailOtp, setEmail, setEmailFormError, setEmailFormStatus,
} from './emailFormSlice';
import {
  requestAddEmail, requestVerifyEmail, requestResendOtpEmail,
} from './emailFormRequests';

export function* handleAddEmail(action:any): Generator<any, any, any> {
  yield put(setEmailFormStatus('loading'));
  try {
    const response = yield call(
      requestAddEmail,
      { email: action.payload.email }
    );
    const { data } = response;
    if (data?.message) {
      yield put(setEmail({ email: action.payload.email }));
    }
  } catch (error: any) {
    yield put(setEmailFormError({
      isError: true,
      type: 'add_email',
      message: error?.response?.data?.message || 'Something went wrong! Try again.',
    }));
  }
}

export function* handleVerifyEmail(action:any): Generator<any, any, any> {
  yield put(setEmailFormStatus('loading'));
  try {
    const response = yield call(
      requestVerifyEmail,
      { email: action.payload.email, otp: action.payload.otp }
    );

    const { data } = response;

    if (data?.message === 'Email verified successfully') {
      yield put(setEmailFormStatus('success'));
      yield put(setUserDetails(data?.user));
    }
  } catch (error: any) {
    if (error?.response?.data?.message === 'max attempts reached') {
      yield put(setEmailFormError({
        isError: true,
        type: 'verify_email',
        message: 'OTP has expired. Please request for a new OTP',
      }));
    } else {
      yield put(setEmailFormError({
        isError: true,
        type: 'verify_email',
        message: error?.response?.data?.message,
      }));
    }
  }
}

export function* handleResendOtpEmail(action:any): Generator<any, any, any> {
  yield put(setEmailFormStatus('loading'));
  try {
    const response = yield call(
      requestResendOtpEmail,
      { email: action.payload.email }
    );
    const { data } = response;
    if (data?.message) {
      // yield put(setEmailFormStatus('success'));
      yield put(setResendEmailOtp(true));
    }
  } catch (error: any) {
    yield put(setEmailFormError({
      isError: true,
      type: 'resend_otp',
      message: error?.response?.data?.message || 'Something went wrong! Try again.',
    }));
  }
}
